import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styling"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SmartContainer, RichText } from '@uswitch/ev-core/react';
import { UswInfoOutline } from '@uswitch/spark-icons/usw';
import richTextStyles from '@uswitch/ev-utils/rich-text/styles';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var RichTextBlock = function RichTextBlock(_ref) {
  var styling = _ref.styling,
      props = _objectWithoutProperties(_ref, _excluded);

  var variant = pickVariant('elements', 'rich-text-block', props.variant);
  styling = _objectSpread(_objectSpread({}, richTextStyles), styling);
  return _jsxs(SmartContainer, {
    parentContentType: props.parentContentType,
    variant: variant,
    styling: styling,
    children: [(props === null || props === void 0 ? void 0 : props.variant) === 'disclaimer' ? _jsx(UswInfoOutline, {
      size: 40
    }) : null, _jsx(RichText, _objectSpread({}, props))]
  });
};

var pickVariant = function pickVariant(type, component, variant) {
  var vari = variant === undefined || variant === 'base' ? 'base' : "variants.".concat(variant);
  return "".concat(type, ".").concat(component, ".").concat(vari);
};

export default RichTextBlock;
//# sourceMappingURL=index.js.map